import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient, HttpHeaders }from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PostResponse } from '../models/Attachment'
import {PagedResponseCompletionYears} from '../models/CompletionYears';

@Injectable({
  providedIn: 'root'
})


export class ActualService {
  readonly APIURL = environment.APIURL;
  
  constructor(private messageService:MessageService, private http:HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  updateKaizenActuals(val: any): Observable<PostResponse> 
  {
    return this.http.put<PostResponse>(this.APIURL + '/KaizenActual', val);
  }

  getKaizenCompletionYears(): Observable<PagedResponseCompletionYears>
  {
    const KaizenActualCompletionYears =this.http.get<PagedResponseCompletionYears>(this.APIURL+'/KaizenActual/GetKaizenActualCompletionYears/' );
    this.messageService.add(`Actual Service: fetched Completion Years`);
    return KaizenActualCompletionYears;
  }

}